import { SubPageLayout } from '../../../../staff/sub-page-layout';
import { PageLayoutProps } from '../../../../../shared/menu-component';
import { SendReportLayoutContainer } from '../section-layout.container';

interface ActiveCaseSummaryProps {
    pageLayouts: PageLayoutProps[];
    caseId: string;
    isApplicantSection?: boolean;
}

export const ActiveCaseSummary: React.FC<ActiveCaseSummaryProps> = (props) => {
  return (
    <SubPageLayout>
        <div
            style={{
              marginBottom: '-90px'
            }}
        ></div>
      <SendReportLayoutContainer pageLayouts={props.pageLayouts} caseId={props.caseId ?? ""} isApplicantSection={props.isApplicantSection}/>
    </SubPageLayout>
  );
};
